var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8375 7.5749H1V14.0499H3.1V9.8499C3.1 9.8499 4.5 8.7999 5.8125 8.7999C6.6 8.7999 6.95 9.2374 6.95 9.9374V14.0499H9.05V9.9374C9.6625 9.4124 10.975 8.8874 11.675 8.8874C12.6375 8.8874 12.9 9.3249 12.9 10.1124V14.0499H15V9.9374C15 8.3624 14.0375 7.3999 12.6375 7.3999C11.325 7.3999 9.6625 8.1874 8.875 8.8874C8.525 8.0999 8.0875 7.3999 6.775 7.3999C5.4625 7.3999 3.975 8.0999 3.1 8.7999L2.8375 7.5749Z",
    fill: "#1F8AC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H17V17H19V2Z",
    fill: "#FECB2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneta);
export default __webpack_public_path__ + "static/media/moneta.703f5e6d.svg";
export { ForwardRef as ReactComponent };